// extracted by mini-css-extract-plugin
export default {"hint":"ControlsDialogHint-module__hint--B9wWI"};